import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

const highchartsTooltipContainerZindex = "1301 !important" as any;

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      height: "98%",
      width: "100%",
    },
    chartContainer: {
      height: "100%",
      width: "100%",
      display: "flex",
    },
    highChartsContainer: {
      display: "flex",
      width: "100%",
      flex: "1 1 auto",
      "& .highcharts-container .highcharts-button": {
        cursor: "pointer",
      },
    },
    "@global": {
      ".highcharts-tooltip-container": {
        zIndex: highchartsTooltipContainerZindex,
      },
    },
  });

export default styles;
